import React, { useState, useEffect } from 'react';
import axios from '../Axiosinstance';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button } from '@material-ui/core';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { TablePagination } from '@material-ui/core';
import * as XLSX from "xlsx";
import { TextField } from '@mui/material';
import { buttonBackgroundColor } from '../common';
function StudentStatusTable() {
  const [students, setStudents] = useState([]);
  const [error, setError] = React.useState(null);
  const [success, setSuccess] = React.useState(null);
  const [refreshData, setRefreshData] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");


  // const [page, setPage] = useState(0);
  // const [rowsPerPage, setRowsPerPage] = useState(10);

  // const handleChangePage = (event, newPage) => {
  //   setPage(newPage);
  // };

  // const handleChangeRowsPerPage = (event) => {
  //   setRowsPerPage(parseInt(event.target.value, 10));
  //   setPage(0);
  // };

  useEffect(() => {
    axios.get('getAllRemovedStudents')
      .then(response => {
        setStudents(response.data);
        console.log(response.data);
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }, [refreshData]);

  const handleRetrieve = async (studentId) => {
    try {
      const response = await axios.put(`students/${studentId}/retrieve`);
      if (response.status === 200) {
        const updatedStudents = students.map((student) =>
          student.id === studentId ? { ...student, status: 'active' } : student
        );
        setStudents(updatedStudents);
        setRefreshData(!refreshData); // Trigger re-fetch
        toast.success('Student successfully retrieved.');
      } else {
        toast.error('Failed to retrieve student.');
      }
    } catch (error) {
      toast.error('Error retrieving student.');
    }
  };

  const handleRevertReject = async (id) => {
    try {
      // Make the API request to revert reject
      const response = await axios.put(`registrationadvances/${id}/revertReject`);

      // Check if the request was successful
      if (response.status === 200) {
        setSuccess('Registration Advance successfully reverted.');
        setError(null);
        setRefreshData(!refreshData); // Trigger re-fetch
        toast.success('Registration Advance successfully reverted.');
      } else {
        setError('Failed to revert Registration Advance.');
        setSuccess(null);
        toast.error('Failed to revert Registration Advance.');
      }
    } catch (err) {
      // Handle error
      setError('An error occurred while trying to revert Registration Advance.');
      setSuccess(null);
      toast.error('An error occurred while trying to revert Registration Advance.');
    }
  };
  const exportToExcel = (data, fileName) => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  };

  const maskNRIC_FIN = (value) => {
    if (!value) return "";
    return value.slice(0, -4).replace(/\w/g, "*") + value.slice(-4);
  };

  const filteredStudents = students.filter((student) =>
    [student.name, student.fullname, student.email, student.phone]
      .some(field => field?.toLowerCase().includes(searchTerm.toLowerCase()))
  );


  return (
    <TableContainer component={Paper}>
      <br />
      <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px" }}>

        <TextField
          label="Search By Name"
          variant="outlined"
          margin="normal"
          fullWidth
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}


        />
        <Button
          variant="contained"
          style={{  backgroundColor: buttonBackgroundColor, color: 'white' }}
          onClick={() =>
            exportToExcel(
              filteredStudents.map((student, index) => ({
                "S.NO": index + 1,
                Name: student.name,
                "Full Name": student.fullname,
                NRIC: student.nric,
                Email: student.email,
                Phone: student.phone,
                Gender: student.gender,
                "Date of Birth": student.dob,
                Status: student.approve === "rejected" ? "Rejected" : student.status,
              })),
              "Students_Data"
            )
          }
        >
          Download Excel
        </Button>
      </div>

      <Table>
        <TableHead>
          <TableRow>
            <TableCell style={{ fontWeight: 'bold', fontSize: '1rem' }}>S.No</TableCell>
            <TableCell style={{ fontWeight: 'bold', fontSize: '1rem' }}>Name</TableCell>
            <TableCell style={{ fontWeight: 'bold', fontSize: '1rem' }}>Full Name</TableCell>
            <TableCell style={{ fontWeight: 'bold', fontSize: '1rem' }}>NRIC</TableCell>
            {/* <Table style={{ fontWeight: 'bold', fontSize: '1rem' }}Cell>Student ID</TableCell> */}
            <TableCell style={{ fontWeight: 'bold', fontSize: '1rem' }}>Email</TableCell>
            <TableCell style={{ fontWeight: 'bold', fontSize: '1rem' }}>Phone</TableCell>
            <TableCell style={{ fontWeight: 'bold', fontSize: '1rem' }}>Gender</TableCell>
            <TableCell style={{ fontWeight: 'bold', fontSize: '1rem' }}>Date of Birth</TableCell>
            <TableCell style={{ fontWeight: 'bold', fontSize: '1rem' }}>Status</TableCell>
            {/* <Table style={{ fontWeight: 'bold', fontSize: '1rem' }}Cell>Mode</TableCell> */}
            {/* <Table style={{ fontWeight: 'bold', fontSize: '1rem' }}Cell>Profile URL</TableCell> */}
            {/* <Table style={{ fontWeight: 'bold', fontSize: '1rem' }}Cell>Remarks</TableCell> */}
            <TableCell style={{ fontWeight: 'bold', fontSize: '1rem' }}>Retrieve</TableCell>

          </TableRow>
        </TableHead>
        <TableBody>
          {filteredStudents
            // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((student, index) => (
              <TableRow key={student.id}>
                {/* <TableCell>{page * rowsPerPage + index + 1}</TableCell> */}
                <TableCell>{index + 1}</TableCell>
                <TableCell>{student.name}</TableCell>
                <TableCell>{student.fullname}</TableCell>
                {/* <TableCell>{student.nric}</TableCell> */}
                <TableCell>{(student.nric)}</TableCell>
                {/* <TableCell>{student.studentId}</TableCell> */}
                <TableCell>{student.email}</TableCell>
                <TableCell>{student.phone}</TableCell>
                <TableCell>{student.gender}</TableCell>
                <TableCell>{student.dob}</TableCell>
                {/* <TableCell>{student.status}</TableCell> */}
                <TableCell>
                  {student.approve === 'rejected' ? 'rejected' : student.status}
                </TableCell>
                {/* <TableCell>{student.mode}</TableCell>
              <TableCell>{student.profileUrl}</TableCell>
              <TableCell>{student.remarks}</TableCell> */}
                <TableCell>
                  {/* <Button variant="contained" color="primary" onClick={() => handleRetrieve(student.id)}>
    Retrieve
  </Button> */}
                  <Button
                    variant="contained"
                    color="success"
                    onClick={() => {
                      if (student.status === 'rejected') {
                        // handleRevertReject(student.id);
                        handleRevertReject(student.registrationAdvanceId);
                      } else {
                        handleRetrieve(student.id);
                      }
                    }}
                  >
                    {student && student.status === 'rejected' ? 'Revert Reject' : 'Retrieve'}
                  </Button>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
      {/* <TablePagination
        rowsPerPageOptions={[10, 25, 50]}
        component="div"
        count={students.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      /> */}
    </TableContainer>

  );
}

export default StudentStatusTable;
